// @ts-ignore
import config  from '../../config/defaults';
import {rrWidget} from "../../rr-widget";
import axios from 'axios';
import configEnv  from '../../config/environmentConfig';
import defaultConfig  from '../../config/defaults';
import { Utils } from "../../utils/utils";
import { ReadPanel } from "../readPanel";
import { PageNav } from "../pageNav/pageNav";
import { brandConfig } from "../../brandConfig";
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

export class Carousel extends rrWidget {
    carouselOptions = {};
    initCarouselArr = [];
    reviewMediaInfo = [];
    mediaOverlayList;
    naturalHeight;
    naturalWidth;
    mediaAllPageNumber;
    constructor() {
        super();
        this.carouselOptions = {
            container: config.container,
            startSlideshow: config.startSlideshow,
            closeOnEscape: config.closeOnEscape,
            enableKeyboardNavigation: config.enableKeyboardNavigation,
            toggleControlsOnSlideClick: config.toggleControlsOnSlideClick,
            toggleControlsOnEnter: config.toggleControlsOnEnter,
            toggleSlideshowOnSpace: config.toggleSlideshowOnSpace,
            hidePageScrollbars: config.hidePageScrollbars,
            continuous: config.continuous,
            youTubePlayerVars: {
                autoplay:1,
                rel: 0
            },
            youTubeClickToPlay: false,
            fullscreen: config.fullscreen
        };
        this.initCarouselArr= [];
        this.reviewMediaInfo = [];
        this.naturalHeight;
        this.naturalWidth;
        this.mediaAllPageNumber;
        this.mediaOverlayList =[];
    }

    initSwiper(reviews, mediaCount?: number) {
        let self = this;
        const carousalTiles = Utils.getDeviceUserAgent()['carousalTiles'];
        const myCustomSlider = document.querySelectorAll('.kr-swiper .swiper');
        const myCustomPagination = document.querySelectorAll('.kr-swiper .swiper-pagination');
        var swiper = [];

        for (let i = 0; i < myCustomSlider.length; i++) {
            if (!myCustomSlider[i].classList.contains('swiper-initialized')) {
                myCustomSlider[i].classList.add('swiper-container-' + i);
                myCustomPagination[i].classList.add('swiper-pagination-' + i);
                let totalMedia = document.querySelector('.swiper-container-' + i).getAttribute('data-count');

                swiper[i] = new Swiper('.swiper-container-' + i, {
                    modules: [Navigation, Pagination, Scrollbar, A11y],
                    speed: 500,
                    slidesPerView: (carousalTiles + .25),
                    slidesPerGroup: carousalTiles,
                    spaceBetween: 10,
                    pagination: {
                        el: '.swiper-pagination-' + i,
                        type: 'bullets',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                });
                swiper[i].on('slideChange', function (e) {
                    let currentPage = e.snapIndex;
                    self.getNextMediaSlide(currentPage, Utils.getDeviceUserAgent()['userAgent'], '.swiper-container-' + i, true);
                    document.querySelector('.swiper-container-' + i + ' .swiper-wrapper').setAttribute('data-page', (currentPage + 1).toString());
                });
            }
        }
        
        if(mediaCount) {
            let idVal = 'Kritique-all-media',
                formatData = self.formatMediaData(reviews, mediaCount),
                reviewMediaData = self.mediaData(formatData);
            self.initCarousel(reviewMediaData, idVal);
            self.tabBackToCustomerMediaList();
        } else {
            reviews.forEach((value, index) => {
                let reviewMediaData = self.mediaData(value.reviewMedia),
                    idVal = value._id;
                self.initCarousel(reviewMediaData, idVal);
            })
            self.lazyloadMethod(true);
        }
    }

    getNextMediaSlide(pageNumber: any, userAgent: any, element: string, nextSlide: boolean) {
        let self = this;
        let readElement = document.querySelector('[data-readpanel-template]') as HTMLElement;
        const carousalTiles = Utils.getDeviceUserAgent()['carousalTiles'];
        let brand = rrWidget.prototype.brand,
        locale = rrWidget.prototype.locale,
        entityId = readElement && readElement.dataset['entityId'] ? readElement.dataset['entityId'] : readElement.dataset['uniqueId'],
        t = this;
        let checkData = document.querySelector(element + ' [data-index="' + (pageNumber * carousalTiles) + '"]') ? document.querySelector(element + ' [data-index="' + (pageNumber * carousalTiles) + '"]').getAttribute('data-review-src') : '';
        if (!checkData) {
            axios({
                method: 'get',
                url: configEnv.baseUrl + '/widget/mediaView',
                params: {
                    brand,
                    locale,
                    entityId,
                    pageNumber,
                    userAgent,
                    apikey: brandConfig.apikey,

                },
                headers: {
                    contentType: 'application/json'
                },
            }).then(function (response) {
                for (let i = 0; i < carousalTiles; i++) {
                    if (document.querySelector(element + ' [data-index="' + (pageNumber * carousalTiles + i) + '"]')) {
                        document.querySelector(element + ' [data-index="' + (pageNumber * carousalTiles + i) + '"]').setAttribute('data-review-src', response.data.reviews[i].reviewMedia.url);
                        document.querySelector(element + ' [data-index="' + (pageNumber * carousalTiles + i) + '"] img').setAttribute('src', response.data.reviews[i].reviewMedia.url);   
                    }
                }
                if (nextSlide) {
                    self.getNextMediaSlide(pageNumber + 1, Utils.getDeviceUserAgent()['userAgent'], element, false);
                }
            })
        } else {
            self.getNextMediaSlide(pageNumber + 1, Utils.getDeviceUserAgent()['userAgent'], element, false);
        }
    }

    blueImpLoad(): boolean {
        require('../../assets/blueimp/js/blueimp-gallery.min.js');
        require('../../assets/blueimp/css/blueimp-gallery.min.css');
        return;
    }

    getSlideHTML(thumbnailUrl: string, normalUrl: string, caption: string, count: number, youtube?: string): string {

        let youtubeID = youtube ? ' data-videoid='+youtube + ' youtube='+youtube : '',
            overLayClass = youtube ? ' class="kr-carousel-thumbnail lazy kr-img-overlay"': ' class="lazy kr-carousel-thumbnail"';
            // overLayDiv = youtube ? '<div id="text">Overlay Text</div>': '',
        normalUrl = youtube ? normalUrl+'?rel=0': normalUrl;
        thumbnailUrl = youtube ? thumbnailUrl : normalUrl;
        let mediaLinkImgElem = '<img '+overLayClass+' data-src='+thumbnailUrl+' loading=lazy alt="'+caption+'"></img>'
        let linkAnchorElem = '<a id="slider'+count+'" class="kr-carousel-link" data-index='+ count +youtubeID+' preload="auto" href='+normalUrl+' title="'+caption+'" data-gallery>'+mediaLinkImgElem+'</a>';
        return linkAnchorElem;
    }

    //Media Data (param1)
    getMediaData(media: Array<any>, id: string): object {
        let mediaLinkElem = '<div class="kr-media-links" id=link'+id+'>',
            mediaArr = [],
            carouselCount = 0;
        if (media) {
            if (!this.BILibLoaded){
                this.blueImpLoad();
            }
            media.forEach((value, index) => {
                if(value.ReviewImages[0]){
                    value = value.ReviewImages[0];
                    let mediaItem = {};
                    mediaItem['href'] =value.ReviewImageURL || value.ReviewImageThumbnailURL
                    mediaItem['thumbnail'] =value.ReviewImageThumbnailURL
                    mediaItem['title'] =value.ReviewImageCaption ? '"'+value.ReviewImageCaption+'"' : ''
                    mediaArr.push(mediaItem);
                    mediaLinkElem += this.getSlideHTML(mediaItem['thumbnail'], mediaItem['href'], mediaItem['title'], carouselCount);
                    carouselCount +=1;
                }else{
                    value = value.ReviewVideos[0];
                    let mediaVideoItem = {};
                    mediaVideoItem['href'] =value.ReviewVideoIframeURL
                    mediaVideoItem['poster'] =value.ReviewVideoThumbnailURL
                    mediaVideoItem['type'] = 'text/html'
                    mediaVideoItem['id'] = value.ReviewVideoId
                    mediaVideoItem['youtube'] = value.ReviewVideoId
                    mediaVideoItem['title'] = value.ReviewImageCaption ? '"'+value.ReviewImageCaption+'"' : ''
                    mediaVideoItem['preload'] = 'auto'
                    mediaVideoItem['videoUrl'] = value.ReviewVideoURL
                    mediaArr.push(mediaVideoItem);

                    let videoThumbnail = mediaVideoItem['poster']? mediaVideoItem['poster']:'https://img.youtube.com/vi/'+mediaVideoItem['id']+'/default.jpg';
                    mediaLinkElem +=this.getSlideHTML(videoThumbnail, mediaVideoItem['href'], mediaVideoItem['title'], carouselCount, mediaVideoItem['youtube']);
                    carouselCount +=1;
                }
            });
        }
        mediaLinkElem += '</div>';
        return {'mediaArr': mediaArr, 'mediaHTML': mediaLinkElem};
    }

    // function to init cache slide
    initStoredMedia(pageNumber: number, reviews: Array<any>, mediaData: Array<any>, pageType: string, numberOfRecordsPerPage: number, finalPage: number, totalMediaCount: number): void {
        let slideMin = pageNumber === 1 ? 0 : (pageNumber - 1) * numberOfRecordsPerPage,
            slideMax = pageNumber === 1 ? pageNumber * numberOfRecordsPerPage - 1 : pageNumber * numberOfRecordsPerPage;
        localStorage.setItem('rrReviewMediaAllData', JSON.stringify({
            pageNumber: pageNumber,
            mediaArr: mediaData,
            finalPage: finalPage,
            startIndex: slideMin,
            endIndex: slideMax,
            pageType: pageType,
            pageSize: numberOfRecordsPerPage,
            totalMediaCount: totalMediaCount,
            mediaReviews: reviews
        }));
        return;
    }



    // Click Function for pagination
    initPrevMedia(slideIndex: string): void {
        slideIndex = document.querySelector("#blueimp-gallery .slide-active").getAttribute('data-index');
        if(slideIndex){
            let localStoreData = JSON.parse(localStorage.getItem('rrReviewMediaAllData')),
                pagination = {};
            pagination['enable'] = true;
            pagination['type'] = '';
            if(slideIndex < localStoreData.startIndex){
                pagination['type'] = 'prev';
                localStoreData.pageNumber = localStoreData.pageNumber - 1;
            }else if(slideIndex > localStoreData.endIndex){
                pagination['type'] = 'next';
                localStoreData.pageNumber = localStoreData.pageNumber + 1;
            }
        }
    };

    // Function to trigger next media slide from popup last media
    initNextMedia(): void{
        let localStoreData = JSON.parse(localStorage.getItem('rrReviewMediaAllData')),
            pagination = {};
        pagination['enable'] = true;
        localStoreData.pageNumber = localStoreData.pageNumber + 1;
        pagination['type'] = 'next';
    };

    // function for media pagination
    mediaPagination(): void{
        document.querySelectorAll('.kr-mediaAllPagination').forEach(item => {
            item.addEventListener('click', function(ev){
                let localStoreData = JSON.parse(localStorage.getItem('rrReviewMediaAllData')),
                    pagination = {};
                pagination['enable'] = true;
                if(this.classList.contains('next')){
                    localStoreData.pageNumber = localStoreData.pageNumber + 1;
                    pagination['type'] = 'next';
                    this.addMediaCarouselListener('next');
                }else{
                    localStoreData.pageNumber = localStoreData.pageNumber - 1;
                    pagination['type'] = 'prev';
                    this.addMediaCarouselListener('prev');
                }
            })
        });
    };

    // Function for mobile pagination
    mediaMobilePagination(direction): void{
        let localStoreData = JSON.parse(localStorage.getItem('rrReviewMediaAllData')),
            pagination = {};
        pagination['enable'] = true;
        pagination['type'] = '';
        if(direction === 'left'){
            localStoreData.pageNumber = localStoreData.pageNumber + 1;
            pagination['type'] = 'next';
            this.addMediaCarouselListener('next');
        }else if(direction === 'right'){
            localStoreData.pageNumber = localStoreData.pageNumber - 1;
            pagination['type'] = 'prev';
            this.addMediaCarouselListener('prev');
        }
    }

    addMediaCarouselListener(type: string): void{
        let event;
        if(type==='next') {
            if(window.ratingReview && window.ratingReview.events && window.ratingReview.events.rrCarouselNextMediaPage) {
                window.ratingReview.events.rrCarouselNextMediaPage();
            }
            const renderEvent = new Event('rrCarouselNextMediaPage');
            document.dispatchEvent(renderEvent);
            event = new CustomEvent("rrMediaCarouselPagination", {
                detail: {
                    type: 'next'
                }
            });
        }
        if(type==='prev') {
            if(window.ratingReview && window.ratingReview.events && window.ratingReview.events.rrCarouselPrevMediaPage) {
                window.ratingReview.events.rrCarouselPrevMediaPage();
            }
            const renderEvent = new Event('rrCarouselPrevMediaPage');
            document.dispatchEvent(renderEvent);
            event = new CustomEvent("rrMediaCarouselPagination", {
                detail: {
                    type: 'prev'
                }
            });
        }
        document.dispatchEvent(event);
    }

    // onClick init blueImp Carousel
    initCarousel(links: Array<any>, id: string): void{
        let t = this,
            carouselOptions = this.carouselOptions;
        if(links.length>0) {
            let linkElem = document.querySelectorAll('.link'+id);
            if(linkElem.length) {
                let handleEventListener = (event)=> {
                    event.preventDefault();
                    // event = event;
                    //let localStoreData = JSON.parse(localStorage.getItem('rrReviewMediaAllData'));
                    carouselOptions['index'] = (event.target as HTMLElement).parentElement.dataset["index"] ? parseInt((event.target as HTMLElement).parentElement.dataset["index"]) : parseInt((event.target as HTMLElement).dataset["index"]);
                    if(!window.hasOwnProperty('ratingReview')){
                        window.ratingReview = {};
                    }
                    if(!window.ratingReview.hasOwnProperty('carouselData')) {
                        window.ratingReview['carouselData'] = {};
                    }
                    if (event.target && (event.target as HTMLAnchorElement).href) {
                        window.ratingReview['carouselData']["destinationImg"] = (event.target as HTMLAnchorElement).href
                    } else {
                        window.ratingReview['carouselData']["destinationImg"] = (event.target as HTMLElement).parentElement.dataset["src"] ? (event.target as HTMLElement).parentElement.dataset["src"] : (event.target as HTMLElement).dataset["src"];
                    }
                    carouselOptions['onopen'] = function() {
                        let closeGallerySelector = (document.querySelector('.blueimp-gallery-svgasimg>.close') as HTMLElement);
                        setTimeout(()=> {
                            if(closeGallerySelector) {
                                closeGallerySelector.focus();
                            }
                        },500);
                    }
                    carouselOptions['onopened'] = function() {
                        t.updateCssOnSlideChange(links, carouselOptions);
                        let videoPlaySelector = document.querySelectorAll('.slide-active .video-iframe .video-play');
                        if(videoPlaySelector.length){
                            let element: HTMLElement = videoPlaySelector[0] as HTMLElement;
                            element.click();
                            if(window.ratingReview && window.ratingReview.events && window.ratingReview.events.rrVideoClickAnalytic) {
                                window.ratingReview.events.rrVideoClickAnalytic(event);
                            }
                            const videoClickEvent = new Event('rrVideoClickAnalytic');
                            document.dispatchEvent(videoClickEvent);
                            t.removevideoOverlay();
                        } else {
                            if(window.ratingReview && window.ratingReview.events && window.ratingReview.events.rrCarouselOpen) {
                                window.ratingReview.events.rrCarouselOpen(event);
                            }
                            const carouselOpenEvent = new Event('rrCarouselOpen');
                            document.dispatchEvent(carouselOpenEvent);
                        }
                    };
                    carouselOptions['onslide'] = (index, slide) => {
                        var text = document.querySelector(".kr-carousel-link").getAttribute("data-description");
                        var node = document.querySelector(".kr-carousel .description");
                        node.innerHTML = "";
                        if (text) {
                            node.appendChild(document.createTextNode(text));
                        }
                        var carousalCaptionTitle = document.querySelector(".kr-carousel .title");
                        var carousalCaptionContainer = document.querySelector(".kr-caption-container");
                        if (carousalCaptionTitle.innerHTML === "") {
                            carousalCaptionContainer.classList.add("kr-hide")
                        }
                        else {
                            carousalCaptionContainer.classList.remove("kr-hide")
                        }
                        if(carouselOptions['index']<index) {
                            if(window.ratingReview && window.ratingReview.events && window.ratingReview.events.rrCarouselNextSlide) {
                                window.ratingReview.events.rrCarouselNextSlide(event);
                            }
                            const rrCarouselNextSlideEvent = new Event('rrCarouselNextSlide');
                            document.dispatchEvent(rrCarouselNextSlideEvent);
                            t.initCarouselListener();
                        } else if(carouselOptions['index']>index){
                            if(window.ratingReview && window.ratingReview.events && window.ratingReview.events.rrCarouselPrevSlide) {
                                window.ratingReview.events.rrCarouselPrevSlide(event);
                            }
                            const rrCarouselPrevSlideEvent = new Event('rrCarouselPrevSlide');
                            document.dispatchEvent(rrCarouselPrevSlideEvent);
                            t.initCarouselListener();
                        }
                        carouselOptions['index'] = index;
                        t.updateCssOnSlideChange(links, carouselOptions);
                        /*if(id === 'Kritique-all-media'){
                            if(carouselOptions['index'] === (localStoreData.mediaArr.length - 1)){
                                t.initNextMedia();
                            }else{
                                t.initPrevMedia(carouselOptions['index']);
                            }
                        }*/
                    };
                    /*if(id === 'Kritique-all-media') {
                        links = localStoreData.mediaArr;
                    }*/

                    // @ts-ignore
                    blueimp.Gallery(links, carouselOptions);
                };
                linkElem.forEach((linkItem) =>{
                    linkItem.removeEventListener('click', handleEventListener);
                    linkItem.addEventListener('click',handleEventListener)
                    linkItem.addEventListener('keypress', async(event:KeyboardEvent)=>{
                        if (event.key === 'Enter') {
                            await handleEventListener(event);
                            setTimeout( ()=>{
                                (document.querySelector('.blueimp-gallery-svgasimg>.close') as HTMLAnchorElement).focus();
                            }, 500);
                        }
                    });
                })
            }
        }
    }

    lazyloadMethod(loadMoreFlag?: boolean): void {
        let lazyloadThrottleTimeout,
            t= this;
        function lazyload (loadMoreFlag?: boolean) {
            let lazyloadImages = document.querySelectorAll("img.lazy"),
                mediaContainer = document.querySelector('.kr-mediaAll-container .kr-media-links-container');
            if(lazyloadThrottleTimeout) {
                clearTimeout(lazyloadThrottleTimeout);
            }

            if (lazyloadImages.length > 0) {
                lazyloadThrottleTimeout = setTimeout(function() {
                    let scrollTop = window.pageYOffset;
                    let windowInnerHeight =window.innerHeight + scrollTop;
                    if (loadMoreFlag) {
                        mediaContainer = document.querySelector('.kr-media-popup-box');
                        if(mediaContainer && mediaContainer['scrollHeight'] && mediaContainer['offsetTop'] && mediaContainer['offsetHeight']) {
                            windowInnerHeight =mediaContainer['scrollHeight'] + mediaContainer['offsetTop'] + mediaContainer['offsetHeight'];
                        }
                    }
                    for (let i=0; i< lazyloadImages.length; i++){
                        let img =lazyloadImages[i];
                        let imgY = img['y'] ? img['y'] : 0;
                        let inViewBox = loadMoreFlag && mediaContainer? ((mediaContainer['offsetTop'] + + mediaContainer['offsetHeight']+mediaContainer['scrollTop'] + imgY) < windowInnerHeight):((window.outerHeight - window.innerHeight) + imgY + img['offsetTop']) < windowInnerHeight;
                        if(inViewBox) {
                            img['src'] = img['dataset']['src'];
                            img.classList.remove('lazy');
                            if(img){
                                img.addEventListener("load", function(e){
                                    let mediaContainer = (e.currentTarget as HTMLElement).parentElement,
                                        carousalTiles = Utils.getDeviceUserAgent()['carousalTiles'];
                                    let imgContainerWidth = (mediaContainer['offsetWidth'] - (carousalTiles * 10)) / carousalTiles;
                                    if (loadMoreFlag) {
                                        let getUserAgent = Utils.getDeviceUserAgent()['userAgent'];
                                        let numberOfRecords = 5
                                        if(getUserAgent === 'tablet') {
                                            numberOfRecords = 4
                                        } else if(getUserAgent === 'mobile') {
                                            numberOfRecords = 2
                                        }
                                        let containerWidth = (mediaContainer.parentElement.parentElement['offsetWidth'] - (numberOfRecords * 10)) / numberOfRecords;
                                        let containerHeight = containerWidth;
                                        document.querySelectorAll('a.kr-media-popup-list-link').forEach(function(ele, key){
                                            (ele as HTMLAnchorElement).style.width = containerWidth>0 ? containerWidth+'px' : '135px';
                                            (ele as HTMLAnchorElement).style.height = containerHeight>0 ? containerHeight+'px' : '135px';
                                        });
                                        //t.addImageClass(getUserAgent, true);
                                    } else {
                                        mediaContainer = document.querySelector('.kr-mediaAll-container .kr-media-links-container');
                                        if(mediaContainer) {
                                            mediaContainer.querySelectorAll('a.kr-carousel-link').forEach(function(ele, key){
                                                (ele as HTMLAnchorElement).style.width = imgContainerWidth>0 ? imgContainerWidth+'px' : '135px';
                                                (ele as HTMLAnchorElement).style.height = imgContainerWidth>0 ? imgContainerWidth+'px' : '135px';
                                            });
                                        }
                                    }
                                });
                            }
                            t.reviewMediaInfo.push(img['src']);
                        }
                    };
                    if(lazyloadImages.length == 0) {
                        if(loadMoreFlag) {
                            let timer, count=0;
                            timer = setInterval(function() {
                                let $mediaPopBox = document.querySelector('.kr-media-popup-box');
                                if ($mediaPopBox || count > 20) {
                                    clearInterval(timer);
                                    $mediaPopBox.removeEventListener("scroll", ()=>{
                                        lazyload(true);
                                    });
                                }
                            },100);
                        }
                        else {
                            document.removeEventListener("scroll", () =>{
                                lazyload();
                            });
                        };
                        window.removeEventListener("resize", ()=>{
                            lazyload();
                        });
                        window.removeEventListener("orientationChange", ()=>{
                            lazyload();
                        });
                    }
                }, 20);
            }
        }
        if(loadMoreFlag) {
            let timer, count=0;
            timer = setInterval(function() {
                let $mediaPopBox = document.querySelector('.kr-media-popup-box');
                if (($mediaPopBox && $mediaPopBox!== null) || count > 20) {
                    clearInterval(timer);
                    $mediaPopBox.addEventListener("scroll", ()=>{
                        lazyload(true);
                    });
                    $mediaPopBox.scrollBy(0,100);
                }
            },100);
            let $mediaLinksContainer = (document.querySelector('.kr-media-links-container') as HTMLElement),
                $mediaLinks = document.querySelectorAll('.kr-media-links');
            if ($mediaLinksContainer) {
                document.addEventListener('scroll', () => {
                    if (Utils.isInViewport($mediaLinksContainer)) {
                        lazyload(true);
                    }
                })
            }

            if ($mediaLinks.length) {
                $mediaLinks.forEach((item) =>{
                    document.addEventListener("scroll", ()=>{
                        if (Utils.isInViewport(item as HTMLElement)) {
                            lazyload(true);
                        }
                    });
                })

            }
            window.addEventListener("resize", ()=>{
                lazyload(true);
            });
            window.addEventListener("orientationChange", ()=>{
                lazyload(true);
            });
        } else {
            document.addEventListener("scroll", ()=>{
                lazyload();
            });
        }
        window.addEventListener("resize", ()=>{
            lazyload();
        });
        window.addEventListener("orientationChange", ()=>{
            lazyload();
        });
    }

    formatMediaData(mediaData: Array<any>, mediaCount: number): Array<any>{
        let mediaArr = [];
        mediaData.forEach((value, index) =>{
            mediaArr.push(value.reviewMedia);
        });
        return mediaArr;
    }

    initateAllCarousel(reviews, mediaCount?: number): void {
        let self = this,
            userAgentObj = Utils.getDeviceUserAgent();
        if(mediaCount) {
            let idVal = 'Kritique-all-media',
                formatData = self.formatMediaData(reviews, mediaCount),
                reviewMediaData = self.mediaData(formatData);
            self.initCarousel(reviewMediaData, idVal);
            self.tabBackToCustomerMediaList();
        } else {
            reviews.forEach((value, index) => {
                let reviewMediaData = self.mediaData(value.reviewMedia),
                    idVal = value._id;
                self.initCarousel(reviewMediaData, idVal);
            })
            self.lazyloadMethod(true);
        }
        let getUserAgent = Utils.getDeviceUserAgent()['userAgent'];
        //self.addImageClass(getUserAgent, true);
        window.scrollBy(0,1);
    }

    tabBackToCustomerMediaList() {
        let carouselCloseSelector = document.querySelector('.kr-carousel-close'),
            mediaLinks = document.querySelectorAll('.kr-carousel-link');
        let handleListener = (event) =>{
            if (event.key === 'Enter' && event.key === 'Esc'){
                event.preventDefault();
                (mediaLinks[0] as HTMLElement).focus();
            }
        }
        let handleClickListener = (event) =>{
            (mediaLinks[0] as HTMLElement).focus();
        }
        if(carouselCloseSelector) {
            carouselCloseSelector.removeEventListener('click',handleClickListener);
            carouselCloseSelector.addEventListener('click',handleClickListener);
            carouselCloseSelector.removeEventListener('keydown',handleListener);
            carouselCloseSelector.addEventListener('keydown',handleListener);
        }
    }


    initCarouselListener(): void{
        let classes = {
                playPause: '.slide-active .video-iframe .video-play',
                mediaCarouselNextPage: ".next.kr-mediaAllPagination",
                mediaCarouselPrevPage: ".prev.kr-mediaAllPagination"
            },
            playSelector = document.querySelectorAll(classes.playPause);
        if(playSelector && playSelector.length) {
            window.ratingReview['carouselData'] = {};
            if(playSelector[0]) {
                playSelector[0].addEventListener("click", function(e) {
                    if (window.ratingReview.carouselData && ((e.target as HTMLAnchorElement).href !== window.ratingReview.carouselData.destinationImg)) {
                        window.ratingReview.carouselData.destinationImg = (e.target as HTMLAnchorElement).href;
                        if(window.ratingReview && window.ratingReview.events && window.ratingReview.events.rrVideoClickAnalytic) {
                            window.ratingReview.events.rrVideoClickAnalytic(e);
                        }
                        const videoClickEvent = new Event('rrVideoClickAnalytic');
                        document.dispatchEvent(videoClickEvent);
                    }
                });
            }
        }
    }

    // Update slidecss
    updateCssOnSlideChange(links: Array<any>, carouselOptions: object) : void{
        if(links.length ==1){
            document.querySelector('#blueimp-gallery>.prev').setAttribute("style", "display:none");
            document.querySelector('#blueimp-gallery>.next').setAttribute("style", "display:none");
        }
        else if (carouselOptions['index']==0) {
            document.querySelector('#blueimp-gallery>.prev').setAttribute("style", "display:none");
            document.querySelector('#blueimp-gallery>.next').setAttribute("style", "display:block");
        }
        else if(links.length-1>carouselOptions['index']) {
            document.querySelector('#blueimp-gallery>.prev').setAttribute("style", "display:block");
            document.querySelector('#blueimp-gallery>.next').setAttribute("style", "display:block");
        }
        else if(links.length-1==carouselOptions['index']) {
            document.querySelector('#blueimp-gallery>.prev').setAttribute("style", "display:block");
            document.querySelector('#blueimp-gallery>.next').setAttribute("style", "display:none");
        }
        document.querySelector('#blueimp-gallery>.close').setAttribute("style", "display:block");
    }

    mediaData(mediaData: Array<any>) {
        // let mediaLinkElem = document.querySelector('#link'+id) //;'<div class=kr-media-links id=link'+id+'>';
        let mediaArr = [];
        if (mediaData && mediaData.length) {
            mediaData.forEach((value, index) => {
                let mediaItem = {};
                mediaItem['href'] =value.url;
                mediaItem['thumbnail'] =value.url;
                mediaItem['title'] =value.caption ? '"'+value.caption+'"' : '';
                mediaItem['type'] = 'text/html';
                mediaItem['poster'] =value.thumbnailURL;
                if(value.type.toLowerCase() === 'video') {
                    let youtubeVideoObj = value.url.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/);
                    let ReviewVideoId = youtubeVideoObj && youtubeVideoObj.length>=7 ? youtubeVideoObj[7]: '';
                    mediaItem['thumbnail'] = "https://img.youtube.com/vi/"+ReviewVideoId+"/default.jpg"
                    mediaItem['youtube'] = ReviewVideoId;
                    mediaItem['preload'] = 'auto';
                    if(mediaItem['poster'] && !mediaItem['poster'].length){
                        mediaItem['poster'] = mediaItem['thumbnail'];
                    }
                }
                mediaArr.push(mediaItem);
            });
        }
        return mediaArr;
    }


    // Remove videoOverLay
    removevideoOverlay(): void {
        setTimeout(function() {
            let loadingVideoOverlay = document.querySelectorAll('.video-content.video-iframe.slide-content.video-loading');
            if(loadingVideoOverlay) {
                loadingVideoOverlay[0].classList.remove('video-loading');
                loadingVideoOverlay[0].classList.add('video-playing');
            }
        }, 1000);
    };

    carousalSlide(userAgent: any, direction: any, element:any){
        let swipeDirection : any,
            self= this;
        if(userAgent === 'desktop'){
            let carouseSlideListener = function(ev){
                if(this.classList.contains('next')){
                    swipeDirection = 'right';
                }else{
                    swipeDirection = 'left';
                }
                //self.handleSwipe(swipeDirection, userAgent, element);
            }
            element.querySelectorAll('.kr-mediaAllPagination').forEach(item => {
                item.removeEventListener('click', carouseSlideListener);
                item.addEventListener('click', carouseSlideListener);
            });
        }else{
            swipeDirection = direction;
            //self.handleSwipe(swipeDirection, userAgent, element);
        }
    }


    getNextMediaView(pageNumber, userAgent, element: HTMLElement ){
        let readElement = document.querySelector('[data-readpanel-template]') as HTMLElement;
        let brand = rrWidget.prototype.brand,
            locale = rrWidget.prototype.locale,
            entityId = readElement && readElement.dataset['entityId'] ? readElement.dataset['entityId'] : readElement.dataset['uniqueId'],
            t = this;
        axios({
            method: 'get',
            url: configEnv.baseUrl + '/widget/mediaView',
            params: {
                brand,
                locale,
                entityId,
                pageNumber,
                userAgent,
                apikey: brandConfig.apikey,

            },
            headers: {
                contentType: 'application/json'
            },
        }).then(function (response) {
            (element.querySelector('.linkKritique-all-media') as HTMLElement).innerHTML +=response.data.view;
            let localStoreData = JSON.parse(localStorage.getItem('rrReviewMediaAllData')),
                formattedMedia = t.formatMediaData(response.data.reviews, localStoreData.totalMediaCount),
                reviewMediaData = t.mediaData(formattedMedia),
                mediaArr = [...localStoreData.mediaArr, ...reviewMediaData];
            localStorage.setItem('rrReviewMediaAllData', JSON.stringify({
                pageNumber: pageNumber-1,
                mediaArr: mediaArr,
                finalPage: localStoreData.finalPage,
                startIndex: (pageNumber-1) * defaultConfig['carousalTiles'][userAgent],
                endIndex: mediaArr.length - 1,
                pageSize: defaultConfig['carousalTiles'][userAgent],
                pageType: 'next',
                totalMediaCount: localStoreData.totalMediaCount,
                mediaReviews: [...localStoreData.mediaReviews, ...response.data.reviews]
            }));
            ReadPanel.prototype.allMediaData = [...localStoreData.mediaReviews, ...response.data.reviews]
            //t.addImageClass(userAgent, true);
            window.scrollBy(0,1);
        })
    }

    handleIndicatorClick(swipeDirection: any, userAgent: string, element: any, self: any){
        //console.log(el.getAttribute('data-page'));
        self.handleSwipe('right', userAgent, element);
    }

    // Media carousal gallery code start here
    //Mobile swipe start here
    swipedetect(userAgent: any, el: any, element: any){

        var touchsurface = el,
        swipedir: any,
        startX: any,
        startY: any,
        elapsedTime: any,
        startTime: any;
        //handleswipe = callback || function(swipedir){};
        let self = this;
        if(touchsurface) {
            touchsurface.addEventListener('touchstart', function (e) {
                let touchobj = e.changedTouches[0]
                swipedir = 'none'
                startX = touchobj.pageX
                startY = touchobj.pageY
                startTime = new Date().getTime() // record time when finger first makes contact with surface
                //e.preventDefault()
            }, false)

            touchsurface.addEventListener('touchmove', function (e) {
                //e.preventDefault() // prevent scrolling when inside DIV
            }, false)

            touchsurface.addEventListener('touchend', function (e) {
                let touchobj = e.changedTouches[0],
                    threshold = 5, //required min distance traveled to be considered swipe
                    restraint = 300, // maximum distance allowed at the same time in perpendicular direction
                    allowedTime = 5000, // maximum time allowed to travel that distance
                    distX = touchobj.pageX - startX, // get horizontal dist traveled by finger while in contact with surface
                    distY = touchobj.pageY - startY; // get vertical dist traveled by finger while in contact with surface
                let newDate = new Date();
                elapsedTime = newDate.getTime() - startTime; // get time elapsed
                if (elapsedTime <= allowedTime) { // first condition for awipe met
                    if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) { // 2nd condition for horizontal swipe met
                        swipedir = (distX < 0) ? 'right' : 'left'; // if dist traveled is negative, it indicates left swipe
                    } else if (Math.abs(distY) >= threshold && Math.abs(distX) <= restraint) { // 2nd condition for vertical swipe met
                        swipedir = (distY < 0) ? 'up' : 'down'; // if dist traveled is negative, it indicates up swipe
                    }
                }
                self.carousalSlide(userAgent, swipedir, element);
                //e.preventDefault()
            }, false)
        }
    };

    closeMediaOverlay(detailFlag?: boolean ) {
        let $mediaPopUpClose = document.getElementById('media-popup-close'),
            bodySelector = document.querySelector('body'),
            $mediaPopUpOpen = document.getElementById('kr-image-gallery-link'),
            t= this;
        if($mediaPopUpClose) {
            $mediaPopUpClose.addEventListener('click', function(e){
                let $lightBox = document.querySelector('#kr-lightbox');
                if($lightBox){
                    document.querySelector('.kr-overlay').remove();
                    document.querySelector('#kr-lightbox').remove();
                    t.listenerForReadPanel();
                    Carousel.prototype.mediaOverlayList = [];
                    bodySelector.classList.remove('kr-overflow');
                }
                if($mediaPopUpOpen) ($mediaPopUpOpen as HTMLElement).focus();
            })
        }
        t.loadMediaOnClick();
    }

    listenerForReadPanel() {
        let readPanelObj = new ReadPanel();
        let PageNavObj = new PageNav();
        let $countSelector = document.querySelector('.kr-review-count-header span');
        let filteredReviewCount = $countSelector ? parseInt($countSelector.innerHTML.split(' ')[0]) : 0;
        readPanelObj.updatePageNav(readPanelObj, filteredReviewCount);
        let UserAgent = Utils.getDeviceUserAgent()['userAgent'];
        let carouselObj = new Carousel();
        //carouselObj.addImageClass(UserAgent);
        carouselObj.initateAllCarousel(ReadPanel.prototype.allMediaData, ReadPanel.prototype.totalMediaCount);
    }

    getMediaView(pageNumber?: number): Promise<any> {
        let self= this;
        return new Promise((resolve) => {
            let readElement = document.querySelector('[data-readpanel-template]') as HTMLElement;
            let entityId = readElement && readElement.dataset['entityId'] ? readElement.dataset['entityId'] : readElement.dataset['uniqueId'];
            let userAgent =  Utils.getDeviceUserAgent()['userAgent'];
            if(!pageNumber) {
                pageNumber = 0;
            }
            this.mediaAllPageNumber = pageNumber;
            axios({
                method: 'get',
                url: configEnv.baseUrl + '/widget/allMediaView',
                params: {
                    brand :rrWidget.prototype.brand,
                    locale : rrWidget.prototype.locale,
                    entityId,
                    pageNumber,
                    userAgent,
                    apikey: brandConfig.apikey,
                },
                headers: {
                    contentType: 'application/json'
                },
            }).then((response)=>{
                if(!Carousel.prototype.mediaOverlayList) {
                    Carousel.prototype.mediaOverlayList = [];
                }
                Carousel.prototype.mediaOverlayList = [...Carousel.prototype.mediaOverlayList, ...response.data.reviews];
                resolve(response.data);
                if((document.querySelector('.kr-media-popup-box') as HTMLElement)) {
                    (document.querySelector('.kr-media-popup-box') as HTMLElement).scrollTop += 130;
                }
            })
        })
    }

    openMediaOverlay() {
        let $mediaPopUpOpen = document.getElementById('kr-image-gallery-link'),
            self= this;
        if($mediaPopUpOpen) {
            let mediaOpenListener = (e) => {
                self.getMediaView()
                    .then((response)=>{
                        let bodySelector = (document.querySelector('body') as HTMLElement);
                        bodySelector.insertAdjacentHTML('beforeend', response.templateView);
                        // readPanelSelector.innerHTML +=response.templateView;
                        self.closeMediaOverlay(false);
                        self.openMediaDetailOverlay();

                        let lightBoxSelector = document.querySelector('#kr-lightbox'),
                            closeSelector = document.querySelector('.kr-media-popup-close'),
                            loadMoreSelector =  document.querySelector('.kr-loadmore-btn'),
                            overlaySelector = document.querySelector('.kr-overlay'),
                            popupSelector = document.querySelector('.kr-media-popup-list-link');
                        if(lightBoxSelector) {
                            overlaySelector.classList.remove('kr-hide');
                            lightBoxSelector.classList.remove('kr-hide');
                            bodySelector.classList.add('kr-overflow');
                        }
                        if(closeSelector) {
                            (closeSelector as HTMLElement).focus();
                        }

                        self.setMediaBoxHeight(bodySelector);
                        self.addTabOrderListener();

                        let handleListener = (event) =>{
                            if (event.key === 'Tab'){
                                event.preventDefault();
                                (closeSelector as HTMLElement).focus();
                            }
                            if (event.shiftKey && event.key == 'Tab') {
                                event.preventDefault();
                                (popupSelector as HTMLElement).focus();
                            }
                        }
                        let handleCloseButtonListener = (event) =>{
                            if (event.shiftKey && event.key == 'Tab') {
                                event.preventDefault();
                                (document.querySelector('.kr-loadmore-btn') as HTMLElement).focus();
                            }
                        }
                        if(loadMoreSelector) {
                            (loadMoreSelector as HTMLButtonElement).addEventListener('keydown', (event) => {
                                handleListener(event);
                            });
                        }
                        if(closeSelector ) {
                            (closeSelector as HTMLButtonElement).addEventListener('keydown', (event) => {
                                handleCloseButtonListener(event);
                            });
                        }
                    }).then(()=>{
                    let timer, count=0;
                    timer = setInterval(function() {
                        if (document.querySelectorAll('.kr-media-popup-list-link').length || count > 10) {
                            clearInterval(timer);
                            self.lazyloadMethod(true);
                        }
                    }, 2000);

                })
            };
            $mediaPopUpOpen.removeEventListener('click', mediaOpenListener);
            $mediaPopUpOpen.addEventListener('click', mediaOpenListener);


        }
    };

    addTabOrderListener() {
        let closeSelector = document.querySelector('.kr-media-popup-close'),
            popupSelector = document.querySelector('.kr-media-popup-list-link'),
            loadMoreSelector =  document.querySelector('.kr-loadmore-btn'),
            mediaPopListLinkSelector = document.querySelectorAll('.kr-media-popup-list-link'),
            mediaLength = mediaPopListLinkSelector.length;
        let handleListener = (event) =>{
            if (event.key === 'Tab'){
                event.preventDefault();
                if(loadMoreSelector && !loadMoreSelector.classList.contains('kr-hide')) {
                    (loadMoreSelector as HTMLElement).focus();
                } else {
                    (closeSelector as HTMLElement).focus();
                }
            }
        }
        if(mediaPopListLinkSelector && mediaPopListLinkSelector.length) {
            mediaPopListLinkSelector[mediaLength - 1].removeEventListener('keydown', handleListener);
            mediaPopListLinkSelector[mediaLength - 1].addEventListener('keydown', handleListener);
        }
    }

    loadMediaOnClick(){
        const $loadMore = document.querySelector('.kr-loadmore-btn'),
            self= this;
        if($loadMore) {
            $loadMore.addEventListener('click', (e) =>{
                e.preventDefault();
                const button = e.target;
                self.mediaAllPageNumber +=1;
                self.getMediaView(self.mediaAllPageNumber)
                    .then((response)=>{
                        let mediaPopupSelector = document.querySelector('.kr-media-popup-box'),
                            firstLinkSelector = mediaPopupSelector.querySelector('.kr-media-popup-first-link');
                        if(firstLinkSelector && firstLinkSelector.classList.contains('kr-media-popup-first-link')) {
                            firstLinkSelector.classList.remove('kr-media-popup-first-link');
                        }
                        mediaPopupSelector.innerHTML += response.templateView;
                        if(response.count <= response.endIndex) {
                            $loadMore.classList.add('kr-hide');
                        }
                        let userAgent =  Utils.getDeviceUserAgent()['userAgent'];
                        self.lazyloadMethod(true);
                        self.openMediaDetailOverlay();
                        window.scrollBy(0,1);
                        if((document.querySelector('.kr-media-popup-box') as HTMLElement)) {
                            (document.querySelector('.kr-media-popup-box') as HTMLElement).scrollTop += 100;
                        }
                        const mediaFirstLinkPopup = mediaPopupSelector.querySelector('.kr-media-popup-first-link');
                        if(mediaFirstLinkPopup) {
                            (mediaFirstLinkPopup as HTMLElement).focus();
                        }
                        self.addTabOrderListener();
                        this.lazyloadMethod(true);
                    })
            });
        }
    };

    openMediaDetailOverlay() {
        let t = this,
            mediaGridOpenSelector = document.querySelector('.kr-media-popup-grid-open'),
            popupListLink = document.querySelectorAll('.kr-media-popup-list-link');
        popupListLink.forEach(item => {
            let handleListener = async (ev) =>{
                ev.preventDefault();
                let reviewId = (ev.target as HTMLImageElement).dataset.hasOwnProperty('reviewId')? (ev.target as HTMLImageElement).dataset.reviewId:(ev.target as HTMLImageElement).parentElement.dataset.reviewId,
                    reviewMediaId = (ev.target as HTMLImageElement).dataset.hasOwnProperty('reviewMediaId')? (ev.target as HTMLImageElement).dataset.reviewMediaId:(ev.target as HTMLImageElement).parentElement.dataset.reviewMediaId,
                    reviewSrc = (ev.target as HTMLImageElement).dataset.hasOwnProperty('reviewSrc') ? (ev.target as HTMLImageElement).dataset.reviewSrc : (ev.target as HTMLImageElement).parentElement.dataset.reviewSrc;
                t.getMediaDetailView(reviewId, reviewMediaId, reviewSrc)
                    .then((mediaObj) => {
                        let reviewMediaData = t.mediaData(mediaObj['reviewMedia']);
                        let timer, count=0;
                        timer = setInterval(function() {
                            if (document.querySelector('.blueimp-gallery-carousel') || count > 10) {
                                clearInterval(timer);
                                let carousalOption = {
                                    container: '.blueimp-gallery-carousel',
                                    carousel: true,
                                    startSlideshow: config.startSlideshow,
                                    enableKeyboardNavigation: false,
                                    index: mediaObj['indexVal']
                                };
                                carousalOption['onslide'] = (index, slide) => {
                                    let videoPlaySelector = document.querySelectorAll('.slide-active .video-iframe .video-play');
                                    if(videoPlaySelector.length){
                                        let element: HTMLElement = videoPlaySelector[0] as HTMLElement;
                                        element.click();
                                        if(window.ratingReview && window.ratingReview.events && window.ratingReview.events.rrVideoClickAnalytic) {
                                            window.ratingReview.events.rrVideoClickAnalytic(event);
                                        }
                                        const videoClickEvent = new Event('rrVideoClickAnalytic');
                                        document.dispatchEvent(videoClickEvent);
                                        t.removevideoOverlay();
                                    } else {
                                        if(window.ratingReview && window.ratingReview.events && window.ratingReview.events.rrCarouselOpen) {
                                            window.ratingReview.events.rrCarouselOpen(event);
                                        }
                                        const carouselOpenEvent = new Event('rrCarouselOpen');
                                        document.dispatchEvent(carouselOpenEvent);
                                    }
                                    let handleTabListener = (event: KeyboardEvent) => {
                                        event.preventDefault();
                                        if(event.key === 'Tab'){
                                            (mediaGridOpenSelector as HTMLElement).focus();
                                        }
                                    }
                                    let reportBtnSelector = document.querySelector('.kr-view-text-container .report-btn');
                                    setTimeout(()=>{
                                        if(reportBtnSelector) {
                                            reportBtnSelector.addEventListener('keydown', handleTabListener);
                                        }
                                    }, 500)
                                }
                                (mediaGridOpenSelector as HTMLElement).focus();
                                // @ts-ignore
                                blueimp.Gallery(reviewMediaData, carousalOption);
                            }
                            count++
                        }, 500);
                    });
            }
            item.removeEventListener('click', handleListener);
            item.addEventListener('click', handleListener);
            item.addEventListener('keypress', (event:KeyboardEvent)=>{
                if (event.key === 'Enter') {
                    handleListener(event);
                }
            });
        })
    }

    getMediaDetailView(reviewId: string, reviewMediaId: string, reviewSrc: string): Promise<any> {
        return new Promise((resolve, reject) => {
            let userAgent = Utils.getDeviceUserAgent()['userAgent'],
                $mediaPopHeader = document.querySelector('.kr-media-popup-header') as HTMLElement,
                t = this;
            axios({
                method: 'get',
                url: configEnv.baseUrl + '/widget/mediaDetailView',
                params: {
                    userAgent,
                    currentPage: window.location.href,
                    apikey: brandConfig.apikey,
                    brand: rrWidget.prototype.brand,
                    locale: rrWidget.prototype.locale,
                    reviewId: reviewId,
                    reviewMediaId: reviewMediaId,
                    reviewSrc: reviewSrc
                },
                headers: {
                    contentType: 'application/json'
                },
            }).then((response) => {
                const $viewTextContainer = document.querySelector('.kr-view-text-container') as HTMLElement,
                    $detailViewContaier = document.querySelector('.kr-overlay-view-container') as HTMLElement,
                    $mediaPopupContainer = document.querySelector('.kr-media-popup-box-container') as HTMLElement,
                    $mediaGridOpenLink = document.querySelector('.kr-media-popup-grid-open') as HTMLElement;
                $viewTextContainer.innerHTML = response.data.templateView;
                let $lightBox = document.querySelector('#kr-lightbox');
                if ($lightBox) {
                    $detailViewContaier.classList.remove('kr-hide');
                    $mediaPopupContainer.classList.add('kr-hide');
                    $mediaGridOpenLink.classList.remove('kr-hide');
                    $mediaPopHeader.classList.add('kr-media-popup-grid-link-show');
                    document.querySelector('.kr-overlay').classList.remove('kr-hide');
                    $lightBox.classList.remove('kr-hide');
                    t.closeMediaOverlay(true);
                    t.openGridViewFromDetailView();
                    resolve(response.data.mediaObj);
                }
            }).catch((error) => {
                reject(error);
            });
        });
    }

    openGridViewFromDetailView() {
        let t= this,
            $mediaPopHeader = document.querySelector('.kr-media-popup-header') as HTMLElement,
            mediaGridPopupOpen = document.querySelector("#media-grid-popup-open");
        if(mediaGridPopupOpen) {
            mediaGridPopupOpen
                .addEventListener('click', () => {
                    let $lightBox = document.querySelector('#kr-lightbox');
                    if ($lightBox) {
                        const $viewTextContainer = document.querySelector('.kr-view-text-container') as HTMLElement,
                            $detailViewContaier = document.querySelector('.kr-overlay-view-container') as HTMLElement,
                            $mediaPopupContainer = document.querySelector('.kr-media-popup-box-container') as HTMLElement,
                            $mediaGridOpenLink = document.querySelector('.kr-media-popup-grid-open') as HTMLElement,
                            $iframeVideoContainer = document.querySelector('.video-playing iframe') as HTMLElement;
                        if ($iframeVideoContainer) {
                            $iframeVideoContainer.remove();
                        }
                        $detailViewContaier.classList.add('kr-hide');
                        $mediaPopupContainer.classList.remove('kr-hide');
                        $mediaGridOpenLink.classList.add('kr-hide');
                        $mediaPopHeader.classList.remove('kr-media-popup-grid-link-show');
                    }

                })
        }
    }

    setMediaBoxHeight(elem) {

        let mediaBox = elem.querySelector('.kr-media-popup-box'),
            mediaBoxHeight = mediaBox ? mediaBox['clientHeight'] : 0;
        if(mediaBoxHeight && mediaBoxHeight<300 && Utils.getDeviceUserAgent()['userAgent'] === 'tablet') {
            mediaBoxHeight = 700
        } else if (mediaBoxHeight && mediaBoxHeight<300 && Utils.getDeviceUserAgent()['userAgent'] === 'desktop') {
            mediaBoxHeight = 500
        }
        mediaBox.style.height = mediaBoxHeight + 'px';
    }
}